import { Search } from "lucide-react";
 const  SearchComponent = ({ search, onChange, placeholder }) => {
    return (
        <div className="flex justify-between items-center">
            <div className="relative w-[473px] flex items-center">
                <Search
                    className="absolute left-3 text-gray-400"
                    size={18}
                />

                <input
                    placeholder={placeholder}
                    className="pl-10 pr-4 py-2 w-full rounded-md border
                    text-black placeholder:text-[#4C4C4C]
                    focus:outline-none
                    focus:border-inherit
                    focus:ring-0
                    focus:ring-offset-0"
                    value={search}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};
export default SearchComponent